import type { IPropertyTypeValueDescriptor } from '../IPropertyDescriptor';
import { PropertyDescriptorParsingType } from '../IPropertyDescriptor';

export const textDecorationColor: IPropertyTypeValueDescriptor = {
  name: `text-decoration-color`,
  initialValue: 'transparent',
  prefix: false,
  type: PropertyDescriptorParsingType.TYPE_VALUE,
  format: 'color',
};
